import axios from '@/plugins/axios'

export default {
    namespaced: true,
    state: {
        agendaTerms: [],
        search: null,
        page: 1,
        // selectKind: null,
        selectedPublication: null,
    },
    mutations: {
        setAgendaTerms(state, items) {
            state.agendaTerms = items;
        },
        setState(state, payload) {
            Object.assign(state, payload);
        },
        resetState(state) {
            state.search = null;
            state.page = 1;
            // state.selectKind = null;
            state.selectedPublication = null;
        }
    },
    actions: {
        agendaTerms({commit, state}) {
            return state.agendaTerms.length ?
                Promise.resolve(state.agendaTerms) :
                axios.get('/1.1/terms/agenda')
                    .then(response => {
                        commit('setAgendaTerms', response.data || []);
                        return Promise.resolve(response.data || [])
                    }).catch(err => Promise.reject(err));
        }
    }
}
